import { FormView } from '../../UI/view/form-view';
import { FormItemType } from '../../UI/view/component-map';
import { initView } from '../../UI/view/view';
import { bookingsDataSource, bookingsPermissions } from './bookings-datasource';
import {
  addBookingButton,
  MultipleBookingsList,
  NewBookingsList,
  RequestedBookingsList,
  ContainerPendingBookingsList,
  CompletedBookingsList,
  PriorBookingsList,
  CancelledPendingBookingsList,
  CancelledConfirmedBookingsList,
  SearchBookingsList,
} from './bookings-lists';

// Rows the grid shows after its filters + search; badged tabs stay mounted so it stays live.
const filteredCount = (state, dsName: string) => state[dsName]?.filteredTotal ?? 0;

// Legacy Bookings.aspx loads every status grid on page load, so those tabs mount eagerly.
const statusTab = (label: string, dsName: string, component: any) => ({
  label,
  mountOnEnter: false,
  badgeCounter: (state) => filteredCount(state, dsName),
  badgeColor: () => 'secondary',
  items: [{ type: FormItemType.customComponent, component, name: `${dsName}List` }],
});

export const bookingsView = {
  pageHeader: 'Logistics - Bookings',
  permissions: bookingsPermissions,
  breadcrumbs: [{ name: 'Bookings', icon: 'calendar-check', to: '/bookings' }],
  editMode: false,
  items: [
    addBookingButton,
    {
      type: FormItemType.collapsePanel,
      label: 'Customers booked with more than 1 container sailing the same day',
      defaultOpen: true,
      items: [{ type: FormItemType.customComponent, component: MultipleBookingsList, name: 'multipleBookingsList' }],
    },
    {
      type: FormItemType.tab,
      name: 'bookingsTabs',
      items: [
        statusTab('New Bookings', 'newBookings', NewBookingsList),
        statusTab('Bookings Requested', 'requestedBookings', RequestedBookingsList),
        statusTab('Container Pending', 'containerPendingBookings', ContainerPendingBookingsList),
        statusTab('All Completed', 'completedBookings', CompletedBookingsList),
        statusTab('Prior Bookings', 'priorBookings', PriorBookingsList),
        statusTab('Cancelled Pending', 'cancelledPendingBookings', CancelledPendingBookingsList),
        statusTab('Cancelled Confirmed', 'cancelledConfirmedBookings', CancelledConfirmedBookingsList),
        {
          label: 'Search Bookings',
          items: [{ type: FormItemType.customComponent, component: SearchBookingsList, name: 'searchBookingsList' }],
        },
      ],
    },
  ],
} as FormView;

export const BookingsMain = initView({ form: bookingsView, dataSource: bookingsDataSource });
